module.exports = __webpack_public_path__ + "img/modifications--with_mattras.90cfcf76.png";